import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface GenericSearchFilterItemProps {
  label: string;
  filter: any;
  filterType: string;
  handleRemoveFilter: (params: object) => void;
  params: any;
}

const GenericSearchFilterItem: React.FC<GenericSearchFilterItemProps> = ({
  filter,
  filterType,
  handleRemoveFilter,
  params
}) => {
  const { t } = useTranslation('shortlists');

  const renderLabel = () => {
    switch (filterType) {
      case 'user_id':
        return t('GenericSearchFilterItem.filters.belongsToMe');
      case 'created_at':
        // return `Created after ${filter.gte}`;
        return t('GenericSearchFilterItem.filters.createdAt', {
          date: filter.gte
        });
      case 'published':
        return t(
          filter.eq
            ? 'GenericSearchFilterItem.filters.publishedOnly'
            : 'GenericSearchFilterItem.filters.draftOnly'
        );
      case 'archived':
        return filter.eq ? t('GenericSearchFilterItem.filters.archived') : '';
      case 'production_dates':
      case 'events':
        return t('GenericSearchFilterItem.filters.between', {
          startDate: moment(filter.gte).format('Do MMMM'),
          endDate: moment(filter.lte).format('Do MMMM')
        });
      case 'tags':
        function truncate(tags: string[], n: number) {
          if (tags.length > n) {
            const visibleTags = tags.slice(0, n).join(', ');
            return (
              visibleTags +
              t('GenericSearchFilterItem.filters.tags.and') +
              (tags.length - n) +
              t('GenericSearchFilterItem.filters.tags.more')
            );
          }
          return tags.join(', ');
        }

        if (filter.any) {
          return t('GenericSearchFilterItem.filters.tags.any', {
            tag: truncate(filter.any, 3)
          });
        }
        if (filter.match) {
          return t('GenericSearchFilterItem.filters.tags.match', {
            tags: truncate(filter.match, 3)
          });
        }
        return '??';
      default:
        return null;
    }
  };

  return (
    <span key={filter.id} className="PageSearch-activeFilters-item">
      {renderLabel()}{' '}
      <span
        className="PageSearch-activeFilters-item-remove"
        onClick={() => {
          handleRemoveFilter(params);
        }}
      >
        <img src="/images/icon_close_white.svg" alt="" />
      </span>
    </span>
  );
};

export default GenericSearchFilterItem;
